module.exports = __webpack_public_path__ + "static/media/slider3.13278602.jpg";